<div
  class="ddc-read-quiz-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with quiz title and privacy -->
  <div class="sheet-header">
    <div class="header-left">
      <ddc-text-gradient class="text-xl" [_icon]="'question_answer'" [_text]="'Quiz'" [_type]="'1'"></ddc-text-gradient>
      <ddc-privacy [code]="quiz()?.privacy" [withText]="false"></ddc-privacy>
    </div>
    <div class="header-right" *ngIf="quiz()">
      <span class="time-since-creation">{{ quiz()?.time_since_creation }}</span>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Content section -->
  <div class="sheet-content">
    <!-- Owner info -->
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + quiz()?.owner?.username"
      [followerCount]="quiz()?.owner?.followers_count"
      [minimal]="true"
      [subscription]="quiz()?.owner?.subscription"
      [username]="quiz()?.owner?.username"
      [userProfilePic]="quiz()?.owner?.profile_pic"
      (click)="onProfilePicClick()"
    ></ddc-profile-pic>

    <div class="content-row quiz-details">
      <span class="quiz-text">{{ quiz()?.title }}</span>
    </div>

    <!-- Description section -->
    <div class="content-row" *ngIf="quiz()?.description">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <span>Description</span>
      </div>
      <div class="section-content markdown-body">
        <markdown [data]="quiz()?.description"></markdown>
      </div>
    </div>

    <!-- Quick stats row -->
    <div class="content-row" *ngIf="quiz()">
      <div class="quick-stats">
        <div class="stat-item" *ngIf="quiz()?.questions?.length">
          <mat-icon>quiz</mat-icon>
          <span class="stat-value">{{ quiz()?.questions?.length }}</span>
          <span class="stat-label">Questions</span>
        </div>

        <div class="stat-item" *ngIf="quiz()?.notes?.length">
          <mat-icon>note</mat-icon>
          <span class="stat-value">{{ quiz()?.notes?.length }}</span>
          <span class="stat-label">Notes</span>
        </div>

        <div class="stat-item" *ngIf="quiz()?.likes !== undefined">
          <mat-icon>favorite</mat-icon>
          <span class="stat-value">{{ quiz()?.likes }}</span>
          <span class="stat-label">Likes</span>
        </div>

        <div class="stat-item" *ngIf="quiz()?.bookmarks !== undefined">
          <mat-icon>bookmark</mat-icon>
          <span class="stat-value">{{ quiz()?.bookmarks }}</span>
          <span class="stat-label">Bookmarks</span>
        </div>
      </div>
    </div>

    <!-- Question difficulty distribution -->
    <div class="content-row" *ngIf="quiz()?.questions?.length">
      <div class="section-header">
        <mat-icon>grade</mat-icon>
        <span>Difficulty</span>
      </div>
      <div class="difficulty-bars">
        <div class="difficulty-item" *ngFor="let level of getQuestionLevels()">
          <div class="difficulty-header">
            <span class="difficulty-label">{{ level.label }}</span>
            <span class="difficulty-count">{{ level.count }}/{{ quiz()?.questions?.length }}</span>
          </div>
          <div class="progress-track">
            <div class="progress-fill" [ngClass]="level.colorClass" [style.width.%]="level.percentage"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Timing info (minimal) -->
    <div class="content-row" *ngIf="quiz()">
      <div class="timing-info">
        <div class="timing-item" *ngIf="quiz()?.result !== null && quiz()?.result !== undefined">
          <mat-icon>star</mat-icon>
          <span>{{ quiz()?.result }} / 100</span>
        </div>

        <div class="timing-item" *ngIf="quiz()?.completed_time">
          <mat-icon>timer</mat-icon>
          <span>{{ getTimeDisplay() }}</span>
        </div>

        <div class="timing-item" *ngIf="quiz()?.deadline">
          <mat-icon>event</mat-icon>
          <span>{{ formatDeadline(quiz()?.deadline) }}</span>
        </div>

        <div class="timing-item" *ngIf="quiz()?.created_at">
          <mat-icon>calendar_today</mat-icon>
          <span>{{ formatDate(quiz()?.created_at) }}</span>
        </div>

        <div class="timing-item" *ngIf="quiz()?.last_update">
          <mat-icon>update</mat-icon>
          <span>{{ formatDate(quiz()?.last_update) }}</span>
        </div>
      </div>
    </div>

    <!-- Take quiz button -->
    <div class="content-row" *ngIf="quiz()">
      <ddc-button-n-one-action
        class="navbar_network_btn"
        [_icon]="'play_arrow'"
        [_label]="'Take Quiz'"
        [_themeMode]="true"
        (click)="routeToQuiz()"
      ></ddc-button-n-one-action>
    </div>
  </div>
</div>
